// components/Services/Services.js
import React from 'react';
import './Services.css';

function Services() {
  return (
    <section className="services-section" id="services">
      <h2>Why Choose Us?</h2>
      <div className="services-container">
        <div className="service-card">
          <div className="service-image">
            <img src="./assets/servicecardimg1.png" alt="Fast Delivery" />
          </div>
          <h3>Lightning Fast Delivery</h3>
          <p>No more waiting for days to get your fashion fix! With Zyve, your favorite styles are delivered within just 1 hour. Whether it's a last-minute event, a spontaneous outing, or just an instant shopping urge we make sure your wardrobe keeps up with your pace. Shop your desired fashion</p>
        </div>

        <div className="service-card">
          <div className="service-image">
          <img src="./assets/service-2-duplicate.png" alt="Fast Delivery" />
          </div>
          <h3>Curated Elegance</h3>
          <p>We bring fashion closer to you literally! Zyve partners with local boutiques and fashion stores in your city, ensuring you get the freshest styles from trusted sellers nearby. This not only means faster delivery but also helps support small businesses and reduces environmental impact.</p>
        </div>

        <div className="service-card" id="service-card-3">
          <div className="service-image">
            <img src="./assets/servicecardimg3.png" alt="Vendor Onboarding" />
          </div>
          <h3>Seamless Vendor Onboarding</h3>
          <p>Joining Zyve as a seller is quick, simple, and hassle-free. Our platform is designed to make it easy for vendors to list their products, manage orders, and grow their business. With zero upfront costs and a seller-friendly commission structure, we ensure that vendors thrive while customers enjoy a wide range of trendy options.</p>
        </div>
      </div>
    </section>
  );
}

export default Services;